import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Video } from "./VideoBlock";
import { defaultData } from "./VideoBlockDefaultData";
import { meta } from "./VideoBlockMetaData";

export const VideoBlock: BlockExport = {
  type: "component",
  Block: Video,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-video",
    size: 24,
  },
  defaultData,
  meta,
};
